export default {"src":"/_next/static/media/ark.94a9adc5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};